exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".article-teasers .article-teaser.card .extra.content{padding-top:0;font-size:.9em;margin-top:-.5em;line-height:1.2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@ta-interaktiv/react-article-teasers/style/styles.css
// module id = 71
// module chunks = 0